module.exports = __webpack_public_path__ + "img/hand.c2611796.svg";